<template>
    <div class="text-sm">
        <p class="modal-heading mb-4">A patient with that identifier already exists!</p>
        <p>Patient <span class="font-weight-bold" style="font-size: 18px">'{{ patient.firstName }} {{ patient.surname }}'</span> has been found. Click 'Use existing patient' below to continue with the found user. You will not be able to create a new patient with an existing patient identifer.</p>
        <div class="d-flex align-items-center mt-4">
            <button @click="close()" class="btn btn-cancel btn-lg lg-shadow d-flex flex-grow-1 justify-content-center align-items-center">Go back</button>
            <button @click="usePatient()" class="btn btn-success btn-lg lg-shadow d-flex flex-grow-1 ml-3 justify-content-center align-items-center">Use existing patient</button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import FulfilmentOptions from '../../../../Common/enums/FulfilmentOptionsType'
import IssueMethod from '../../../../Common/enums/IssueMethod'

export default {
    name: 'PatientFoundModalComponent',
    
    props: {
        patient: {}
    },

    data() {
        return {
            FulfilmentOptions,
            IssueMethod
        }
    },  

    computed: {
        ...mapGetters({
            myOrganisationSettings: 'OrganisationStore/GetMyOrganisationSettings'
        })
    },

    methods: {
        ...mapActions({
            setPatientDetailsInTestStore: 'TestStore/SetPatientDetails',
            setShippingAddressTypeInTestStoreAction: 'TestStore/SetShippingAddressType',
            setDeliveryMethodInTestStoreAction: 'TestStore/SetDeliveryMethod'
        }),

        async usePatient() {
                this.setPatientDetailsInTestStore(this.patient)

            this.$emit('close')
            
            if(this.myOrganisationSettings.fulfilmentOptions == this.FulfilmentOptions.POST) {
                await this.setDeliveryMethodInTestStoreAction(this.IssueMethod.POST)
                await this.setShippingAddressTypeInTestStoreAction(0)
                return this.$router.push({name: 'TestDetails'})
            }

            if(this.myOrganisationSettings.fulfilmentOptions == this.FulfilmentOptions.IN_PERSON) {
                await this.setDeliveryMethodInTestStoreAction(this.IssueMethod.IN_PERSON)
                await this.setShippingAddressTypeInTestStoreAction(0)
                return this.$router.push({name: 'TestDetails'})
            }
        
            if(this.myOrganisationSettings.fulfilmentOptions == this.FulfilmentOptions.ALL) {
                return this.$router.push({name: 'DeliveryMethod'})
            }

            if(this.issueInPersonOverride) {
                await this.setDeliveryMethodInTestStoreAction(this.IssueMethod.IN_PERSON)
                await this.setShippingAddressTypeInTestStoreAction(0)
                return this.$router.push({name: 'TestDetails'})
            }

            await this.setDeliveryMethodInTestStoreAction(this.IssueMethod.POST)
            await this.setShippingAddressTypeInTestStoreAction(0)
            return this.$router.push({name: 'TestDetails'})
        },

        close() {
            this.$emit('close')
        } 
    }
}
</script>